<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import STLobbyFooterItem from '@/ui/components/lobby/STLobbyFooterItem.vue'
import { NXGRetailClock } from '@nsftx/seven-nxg-retail-vue-sdk/ui'
import STIdleTimerBar from '@/ui/components/footer/STIdleTimerBar.vue'
import STHelpFooterItem from '@/ui/components/help/STHelpFooterItem.vue'
import STTicketCheckFooterItem from '@/ui/components/STTicketCheckFooterItem.vue'
import STTermsAndConditionsFooterItem from '@/ui/components/terms-and-conditions/STTermsAndConditionsFooterItem.vue'
import STLoginFooterItem from '../login/STLoginFooterItem.vue'
import { useCmsConfigStore } from '@/stores/cms/cmsConfigStore'

const { cmsConfig } = storeToRefs(useCmsConfigStore())

const showTermsAndConditionsPage = computed(
  () => cmsConfig.value?.appSettings.showTermsAndConditionsPage !== false
)
</script>

<template>
  <div class="st-footer" data-cy="footerFull">
    <div class="st-footer__left" data-cy="footerLeft">
      <div data-cy="iddleTimer" class="st-footer__timer">
        <STIdleTimerBar />
      </div>
      <STLoginFooterItem />
      <STTermsAndConditionsFooterItem v-if="showTermsAndConditionsPage" />
      <STHelpFooterItem />
      <STLobbyFooterItem />
      <STTicketCheckFooterItem />
    </div>
    <div class="st-footer__right" data-cy="footerRight">
      <NXGRetailClock />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.st-footer {
  height: var(--st-app-bar-height);
  padding: 0 var(--nxgds-alias-spacing-xs);
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--nxgds-alias-spacing-xs);
  border-top: 1px solid var(--nxgds-mapped-color-border-component-page);
  background: var(--nxgds-mapped-color-surface-component-card-default);

  &__left {
    display: flex;
    align-items: center;
    gap: var(--nxgds-alias-spacing-2xs);
    flex: 1 0 0;
    padding: var(--nxgds-alias-spacing-none, 0);
  }

  &__timer {
    margin-right: var(--nxgds-alias-spacing-2xs); // adjust gap since timer has its own spacing
  }
}
</style>
